//@ts-nocheck
import { Route, Routes } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import PageNotFound from "../pages/ErrorPage/PageNotFound";
import DashboardLayout from "../layouts/DashboardLayout";
import Dashboard from "../pages/Dashboard";
import WareHouseList from "../pages/WareHouse/WareHouseList";
import { OrderList } from "../pages/Order/OrderList";
import CustomerList from "../pages/Customer/CustomerList";
import StaffList from "../pages/Staff/StaffList";
import MerchantList from "../pages/Merchant/MerchantList";
import RiderList from "../pages/Rider/RiderList";
import Settings from "../pages/Settings";
import { Overview } from "../pages/Finance/Overview";
import StateList from "../pages/State/StateList";
import DistrictList from "../pages/District/DistrictList";
import ProductTypeList from "../pages/ProductType/ProductTypeList";
import CountryList from "../pages/Country/CountryList";
import CityList from "../pages/City/CityList";
import BranchList from "../pages/Branch/BranchList";
import StatusList from "../pages/Status/StatusList";
import CreateBranch from "../pages/Branch/CreateBranch";
import CreateState from "../pages/State/CreateState";
import CreateCity from "../pages/City/CreateCity";
import CreateCountry from "../pages/Country/CreateCountry";
import CreateProductType from "../pages/ProductType/CreateProductType";
import CreateDistrict from "../pages/District/CreateDistrict";
import CreateWarehouse from "../pages/WareHouse/CreateWarehouse";
import CreateOrder from "../pages/Order/CreateOrder";
import CreateCustomer from "../pages/Customer/CreateCustomer";
import CreateMerchant from "../pages/Merchant/CreateMerchant";
import CreateRider from "../pages/Rider/CreateRider";
import CreateStaff from "../pages/Staff/CreateStaff";
import EditStatus from "../pages/Status/EditStatus";
import EditWarehouse from "../pages/WareHouse/EditWarehouse";
import EditOrder from "../pages/Order/EditOrder";
import EditCustomer from "../pages/Customer/EditCustomer";
import EditStaff from "../pages/Staff/EditStaff";
import EditMerchant from "../pages/Merchant/EditMerchant";
import EditRider from "../pages/Rider/EditRider";
import EditDistrict from "../pages/District/EditDistrict";
import EditProductType from "../pages/ProductType/EditProductType";
import EditCountry from "../pages/Country/EditCountry";
import EditCity from "../pages/City/EditCity";
import EditState from "../pages/State/EditState";
import EditBranch from "../pages/Branch/EditBranch";
import DeliveryChargeList from "../pages/DeliveryCharge/DeliveryChargeList";
import CreateDeliveryCharge from "../pages/DeliveryCharge/CreateDeliveryCharge";
import EditDeliveryCharge from "../pages/DeliveryCharge/EditDeliveryCharge";
import OrderBulkUpload from "../pages/Order/OrderBulkUpload";
import Invoice from "../pages/Finance/Invoice";
import CreateInvoice from "../pages/Finance/CreateInvoice";
import InvoicePreview from "../pages/Finance/InvoicePreview";
import DeliveryChargeTemplateList from "../pages/DeliveryChargeTemplate/DeliveryChargeListTemplate";
import CreateDeliveryChargeTemplate from "../pages/DeliveryChargeTemplate/CreateDeliveryChargeTemplate";
import EditDeliveryChargeTemplate from "../pages/DeliveryChargeTemplate/EditDeliveryChargeTemplate";
import TicketList from "../pages/Ticket/TicketList";
import RiderKMRecord from "../pages/RiderKMRecord/RiderKMRecord";
import NotificationList from "../pages/Notification/NotificationList";
import UserProfile from "../pages/Auth/UserProfile";
import RoleList from "../pages/Auth/RoleList";
import UserList from "../pages/Auth/UserList";
import CreateRole from "../pages/Auth/CreateRole";
import UpdateRole from "../pages/Auth/UpdateRole";
import CreateUser from "../pages/Auth/CreateUser";
import UpdateUser from "../pages/Auth/UpdateUser";
import ReferenceTypeList from "../pages/Settings/ReferenceType/ReferenceTypeList";
import EditReferenceType from "../pages/Settings/ReferenceType/EditReferenceType";
import PaymentMethodList from "../pages/Settings/PaymentMethod/PaymentMethodList";
import EditPaymentMethod from "../pages/Settings/PaymentMethod/EditPaymentMethod";
import ServiceTypeList from "../pages/Settings/ServiceType/ServiceTypeList";
import EditServiceType from "../pages/Settings/ServiceType/EditServiceType";
import CreateServiceType from "../pages/Settings/ServiceType/CreateServiceType";
import CreatePaymentMethod from "../pages/Settings/PaymentMethod/CreatePaymentMethod";
import CreateReferenceType from "../pages/Settings/ReferenceType/CreateReferenceType";
import ManifestList from "../pages/Manifest/ManifestList";
import VehicleCategoryList from "../pages/Settings/VehicleCategory/VehicleCategoryList";
import CreateVehicle from "../pages/Settings/Vehicle/CreateVehicle";
import VehicleList from "../pages/Settings/Vehicle/VehicleList";
import EditVehicle from "../pages/Settings/Vehicle/EditVehicle";
import CreateVehicleCategory from "../pages/Settings/VehicleCategory/CreateVehicleCategory";
import EditVehicleCategory from "../pages/Settings/VehicleCategory/EditVehicleCategory";
import CreateVehicleType from "../pages/Settings/VehicleType/CreateVehicle";
import VehicleTypeList from "../pages/Settings/VehicleType/VehicleList";
import EditVehicleType from "../pages/Settings/VehicleType/EditVehicle";
import CreateManifest from "../pages/Manifest/CreateManifest";
import EditManifest from "../pages/Manifest/EditManifest";
import RunsheetList from "../pages/Runsheet/Runsheet";
import EditRunsheet from "../pages/Runsheet/EditRunsheet";
import CreateRunsheet from "../pages/Runsheet/CreateRunsheet";
import PermissionRequired from "../components/Auth/PermissionRequired";
import AccessControl from "../helpers/acessControl";

const Router = () => {
  return (
    <Routes>
      <Route
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route path={"/"} element={
          <AccessControl children={<Dashboard />}
            allowedPermissions={["can_view_overview"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/warehouse"}
          element={
            <AccessControl children={<WareHouseList />}
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            />
          } />
        <Route path={"/warehouse/edit/:id"} element={
          <AccessControl children={<EditWarehouse />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/create-warehouse"} element={
          <AccessControl children={<CreateWarehouse />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/order/:id?"} element={
          <AccessControl children={<OrderList />}
            allowedPermissions={["can_view_consignment"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/order/bulk-upload"} element={
          <AccessControl children={<OrderBulkUpload />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/order/edit/:id"} element={
          <AccessControl children={<EditOrder />}
            allowedPermissions={["can_editupdate_consignment"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/create-order"} element={
          <AccessControl children={<CreateOrder />}
            allowedPermissions={["can_create_consigment"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/customer"} element={
          <AccessControl children={<CustomerList />}
            allowedPermissions={["can_view_user"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/customer/edit/:id"} element={
          <AccessControl children={<EditCustomer />}
            allowedPermissions={["can_update_user"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/customer/create"} element={
          <AccessControl children={<CreateCustomer />}
            allowedPermissions={["can_create_user"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/staff"} element={
          <AccessControl children={<StaffList />}
            allowedPermissions={["can_view_user"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/staff/edit/:id"} element={
          <AccessControl children={<EditStaff />}
            allowedPermissions={["can_update_user"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/staff/create"} element={
          <AccessControl children={<CreateStaff />}
            allowedPermissions={["can_create_user"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/merchant"} element={
          <AccessControl children={<MerchantList />}
            allowedPermissions={["can_view_user"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/merchant/edit/:id"} element={
          <AccessControl children={<EditMerchant />}
            allowedPermissions={["can_update_user"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/merchant/create"} element={
          <AccessControl children={<CreateMerchant />}
            allowedPermissions={["can_create_user"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/rider"} element={
          <AccessControl children={<RiderList />}
            allowedPermissions={["can_view_user"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/rider/edit/:id"} element={
          <AccessControl children={<EditRider />}
            allowedPermissions={["can_update_user"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/rider/create"} element={
          <AccessControl children={<CreateRider />}
            allowedPermissions={["can_create_user"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/settings"} element={
          <AccessControl children={<Settings />}
            allowedPermissions={["can_view_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/finance-overview"} element={
          <AccessControl children={<Overview />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/status-settings"} element={
          <AccessControl children={<StatusList />}
            allowedPermissions={["can_view_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/status-settings/edit/:id"} element={
          <AccessControl children={<EditStatus />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/district"} element={
          <AccessControl children={<DistrictList />}
            allowedPermissions={["can_view_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/district/edit/:id"} element={
          <AccessControl children={<EditDistrict />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/create-district"} element={
          <AccessControl children={<CreateDistrict />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/product-type"} element={
          <AccessControl children={<ProductTypeList />}
            allowedPermissions={["can_view_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/product-type/edit/:id"} element={
          <AccessControl children={<EditProductType />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/create-product-type"} element={
          <AccessControl children={<CreateProductType />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/country"} element={
          <AccessControl children={<CountryList />}
            allowedPermissions={["can_view_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/country/edit/:id"} element={
          <AccessControl children={<EditCountry />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/create-country"} element={
          <AccessControl children={<CreateCountry />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/city"} element={
          <AccessControl children={<CityList />}
            allowedPermissions={["can_view_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/city/edit/:id"} element={
          <AccessControl children={<EditCity />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/create-city"} element={
          <AccessControl children={<CreateCity />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/state"} element={
          <AccessControl children={<StateList />}
            allowedPermissions={["can_view_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/state/edit/:id"} element={
          <AccessControl children={<EditState />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/create-state"} element={
          <AccessControl children={<CreateState />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/branch"} element={
          <AccessControl children={<BranchList />}
            allowedPermissions={["can_view_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/branch/edit/:id"} element={
          <AccessControl children={<EditBranch />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/create-branch"} element={
          <AccessControl children={<CreateBranch />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />

        <Route path={"/delivery-charge/:templateID?"} element={
          <AccessControl children={<DeliveryChargeList />}
            allowedPermissions={["can_view_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/create-delivery-charge/:templateID"} element={
          <AccessControl children={<CreateDeliveryCharge />}
            allowedPermissions={["can_view_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/delivery-charge/:templateID/edit/:id"} element={
          <AccessControl children={<EditDeliveryCharge />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />

        <Route path={"/delivery-charge-template"} element={
          <AccessControl children={<DeliveryChargeTemplateList />}
            allowedPermissions={["can_view_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/create-delivery-charge-template"} element={
          <AccessControl children={<CreateDeliveryChargeTemplate />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/delivery-charge-template/edit/:id"} element={
          <AccessControl children={<EditDeliveryChargeTemplate />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/invoice"} element={
          <AccessControl children={<Invoice />}
            allowedPermissions={["can_view_dashboard"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/invoice/preview/:id"} element={
          <AccessControl children={<InvoicePreview />}
            allowedPermissions={["can_view_dashboard"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/create-invoice"} element={
          <AccessControl children={<CreateInvoice />}
            allowedPermissions={["can_view_dashboard"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/ticket"} element={
          <AccessControl children={<TicketList />}
            allowedPermissions={["can_view_ticket"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/km-record"} element={
          <AccessControl children={<RiderKMRecord />}
            allowedPermissions={["can_view_kmrecord"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/users"} element={
          <AccessControl children={<UserList />}
            allowedPermissions={["can_view_user"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/create-user"} element={
          <AccessControl children={<CreateUser />}
            allowedPermissions={["can_create_user"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/users/edit/:id"} element={
          <AccessControl children={<UpdateUser />}
            allowedPermissions={["can_update_user"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/roles"} element={
          <AccessControl children={<RoleList />}
            allowedPermissions={["can_view_group"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/role-create"} element={
          <AccessControl children={<CreateRole />}
            allowedPermissions={["can_create_group"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/roles/edit/:id"} element={
          <AccessControl children={<UpdateRole />}
            allowedPermissions={["can_update_group"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/create-reference-type"} element={
          <AccessControl children={<CreateReferenceType />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/reference-type"} element={
          <AccessControl children={<ReferenceTypeList />}
            allowedPermissions={["can_view_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/reference-type/edit/:id"} element={
          <AccessControl children={<EditReferenceType />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/create-payment-method"} element={
          <AccessControl children={<CreatePaymentMethod />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/payment-method"} element={
          <AccessControl children={<PaymentMethodList />}
            allowedPermissions={["can_view_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/payment-method/edit/:id"} element={
          <AccessControl children={<EditPaymentMethod />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/create-service-type"} element={
          <AccessControl children={<CreateServiceType />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/service-type"} element={
          <AccessControl children={<ServiceTypeList />}
            allowedPermissions={["can_view_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/service-type/edit/:id"} element={
          <AccessControl children={<EditServiceType />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/create-vehicle"} element={
          <AccessControl children={<CreateVehicle />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/vehicle"} element={
          <AccessControl children={<VehicleList />}
            allowedPermissions={["can_view_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/vehicle/edit/:id"} element={
          <AccessControl children={<EditVehicle />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/create-vehicle-category"} element={
          <AccessControl children={<CreateVehicleCategory />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/vehicle-category"} element={
          <AccessControl children={<VehicleCategoryList />}
            allowedPermissions={["can_view_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/vehicle-category/edit/:id"} element={
          <AccessControl children={<EditVehicleCategory />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/create-vehicle-type"}  element={
          <AccessControl children={<CreateVehicleType />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/vehicle-type"} element={
          <AccessControl children={<VehicleTypeList />}
            allowedPermissions={["can_view_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/vehicle-type/edit/:id"} element={
          <AccessControl children={<EditVehicleType />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/manifest"} element={
          <AccessControl children={<ManifestList />}
            allowedPermissions={["can_view_manifest"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/manifest/edit/:id"} element={
          <AccessControl children={<EditManifest />}
            allowedPermissions={["can_editupdate_manifest"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/create-manifest"} element={
          <AccessControl children={<CreateManifest />}
            allowedPermissions={["can_create_manifest"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/runsheet"} element={
          <AccessControl children={<RunsheetList />}
            allowedPermissions={["can_view_manifest"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/runsheet/edit/:id"} element={
          <AccessControl children={<EditRunsheet />}
            allowedPermissions={["can_editupdate_manifest"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/create-runsheet"} element={
          <AccessControl children={<CreateRunsheet />}
            allowedPermissions={["CreateManifest"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/profile"} element={<UserProfile />} />
        <Route path={"/notification"} element={
          <AccessControl children={<NotificationList />}
            allowedPermissions={["can_edit_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path="/*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
};

export default Router;
